<template>
    <div class="file-page">
        <page-header :title="title" :items="items" />

        <div v-if="comment.id" class="row">
            <div class="col-xl-9 mb-3">
                <div class="card">
                    <div class="card-body">
                        <div class="col-12 form-group">
                            <label for="details">
                                Details
                            </label>
                            <textarea
                                id="details"
                                :value="comment.details"
                                class="form-control"
                                disabled
                                type="text"
                                rows="4"
                                dir="auto"
                            />
                        </div>
                        <div class="col-12  form-group">
                            <label for="likes">
                                Likes
                            </label>
                            <input
                                id="likes"
                                :value="comment.likes"
                                class="form-control"
                                disabled
                                type="number"
                            />
                        </div>
                        <div class="col-12 form-group">
                            <label for="isReported">
                                Is Reported
                            </label>
                            <b-badge
                                pill
                                class="my-1 px-3 form-control d-flex align-items-center  justify-content-center"
                                :variant="
                                    comment.isReported ? 'danger' : 'success'
                                "
                            >
                                {{ comment.isReported ? 'YES' : 'NO' }}
                            </b-badge>
                            <div
                                v-if="comment.isReported"
                                style="cursor: pointer"
                                class="text-center"
                                @click="$bvModal.show('reports-modal')"
                            >
                                Show reports
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-xl-3 mb-3">
                <div class="card">
                    <div class="card-body">
                        <item-information
                            :edit-mode="true"
                            :sections="{ status: true }"
                            :item="comment"
                            @on-delete-confirm="onDeleteConfirm"
                        />
                    </div>
                </div>
            </div>
        </div>

        <skeleton-loader v-else />

        <reports-modal :id="comment.id" type="comments" />
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import ItemInformation from '@/components/elements/ItemInformation';
import ReportsModal from '@/components/reported-content/ReportsModal';

export default {
    page: {
        title: 'Manage Comment'
    },

    components: {
        ItemInformation,
        ReportsModal
    },

    data() {
        const { id = null } = this.$route.params;

        return {
            title: 'Manage comment',
            items: [
                {
                    text: 'Aguda',
                    to: '/'
                },
                {
                    text: 'Comments',
                    to: '/comments'
                },
                {
                    text: 'Edit',
                    active: true
                }
            ],
            id,
            comment: {}
        };
    },

    async created() {
        try {
            this.comment = await this.getComment(this.id);

            this.comment.author = this.comment.user;
        } catch (error) {
            console.error(error);

            this.$toasterError();
        }
    },

    methods: {
        ...mapActions({
            deleteComment: 'comments/destroy',
            getComment: 'comments/show'
        }),

        async onDeleteConfirm() {
            try {
                await this.deleteComment(this.id);

                this.$router.push('/comments');
            } catch (error) {
                console.error(error);

                this.$toasterError();
            }
        }
    }
};
</script>
